import { CampaignModel, UTMModel } from './models';

export const state = {
  campaign: new CampaignModel(),
  UTMTracking: new UTMModel(),
};

export const mutations = {
  resetCampaign(state) {
    state.campaign = new CampaignModel();
  },
};